import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-season6465data',
  templateUrl: './season6465data.component.html',
  styleUrls: ['./season6465data.component.css']
})
export class Season6465dataComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
